var Context = require('./context').Context;

var ReverseContext = function ReverseContext(delta) {
  this.delta = delta;
  this.pipe = 'reverse';
};

ReverseContext.prototype = new Context();

exports.ReverseContext = ReverseContext;



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/src/contexts/reverse.js
 ** module id = 157
 ** module chunks = 0
 **/